module.exports = __webpack_public_path__ + "img/back_34.d6bd4b6e.svg";